import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";

export const formatDecimalField = value =>
  isNull(value) || isUndefined(value) ? "" : value.toString().replace(".", ",");

export const parseDecimalField = value =>
  isNull(value) || isUndefined(value) || value === ""
    ? null
    : parseFloat(value.replace(",", ".").split(" ").join(""));
